import { all } from "redux-saga/effects";
import { baoCaoSaga } from "./baoCaoSaga";
import { duTruHocBongSaga } from "./duTruHocBongSaga";
import { thongKeSoLuongSinhVienSaga } from "./thongKeSoLuongSinhVienSaga";
import { traTienSinhVienSaga } from "./traTienSinhVienSaga";

export default function* baoCaoSagaWrapper() {
  yield all([
    baoCaoSaga(),
    duTruHocBongSaga(),
    thongKeSoLuongSinhVienSaga(),
    traTienSinhVienSaga(),
  ]);
}
